export const iconFontAwesomeHouseholdDoorClosed = (
	<i className="fa-solid fa-door-closed"></i>
);
